import { useState } from 'react';
import { analytics } from '../../components/Analytics';

export default function JsonFormatter() {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [error, setError] = useState('');

    const formatJson = () => {
        try {
            const parsed = JSON.parse(input);
            const formatted = JSON.stringify(parsed, null, 2);
            setOutput(formatted);
            setError('');
            // 跟踪工具使用
            analytics.trackToolUsage('JSON Formatter - Format');
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Invalid JSON');
            setOutput('');
            // 跟踪错误
            analytics.trackError('JSON Format Error', e instanceof Error ? e.message : 'Unknown error');
        }
    };

    const minifyJson = () => {
        try {
            const parsed = JSON.parse(input);
            const minified = JSON.stringify(parsed);
            setOutput(minified);
            setError('');
            // 跟踪工具使用
            analytics.trackToolUsage('JSON Formatter - Minify');
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Invalid JSON');
            setOutput('');
            // 跟踪错误
            analytics.trackError('JSON Minify Error', e instanceof Error ? e.message : 'Unknown error');
        }
    };

    const clearAll = () => {
        setInput('');
        setOutput('');
        setError('');
    };

    return (
        <div className="max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold mb-2">JSON Formatter</h1>
            <p className="text-gray-600 mb-6">Format, validate, and beautify JSON data</p>

            <div className="grid md:grid-cols-2 gap-6">
                <div>
                    <div className="flex justify-between items-center mb-2">
                        <label className="font-medium">Input</label>
                        <div className="space-x-2">
                            <button onClick={formatJson} className="btn-primary">
                                Format
                            </button>
                            <button onClick={minifyJson} className="btn-secondary">
                                Minify
                            </button>
                            <button onClick={clearAll} className="btn-secondary">
                                Clear
                            </button>
                        </div>
                    </div>
                    <textarea
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder='Paste your JSON here...'
                        className="w-full h-96 p-4 border border-gray-300 rounded-lg font-mono text-sm"
                    />
                </div>

                <div>
                    <label className="font-medium block mb-2">Output</label>
                    {error ? (
                        <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg">
                            <p className="font-semibold">Error:</p>
                            <p>{error}</p>
                        </div>
                    ) : (
                        <textarea
                            value={output}
                            readOnly
                            placeholder="Formatted JSON will appear here..."
                            className="w-full h-96 p-4 border border-gray-300 rounded-lg font-mono text-sm bg-gray-50"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
